export default function Sparkline({ scores = [] }) {
  if (scores.length < 2) return <span className="text-slate-600 text-xs">—</span>;

  const vals = scores.map(s => s.score);
  const min = Math.min(...vals, -0.5);
  const max = Math.max(...vals, 0.5);
  const range = max - min || 1;
  const W = 80, H = 24;

  const pts = vals.map((v, i) => {
    const x = (i / (vals.length - 1)) * W;
    const y = H - ((v - min) / range) * H;
    return `${x},${y}`;
  }).join(' ');

  const last = vals[vals.length - 1];
  const color = last > 0.2 ? '#22c55e' : last < -0.2 ? '#ef4444' : '#94a3b8';

  return (
    <svg width={W} height={H} style={{ overflow: 'visible' }}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}
